import { UPDATE_NAV } from 'packs/constants/actionTypes'

export function updateNavButtons(val) {
  return {
    type: UPDATE_NAV,
    current: val,
  };
}
